import React from 'react'
import styled from '@emotion/styled'
import { TabButton, Tabs } from '@mobi/component-library/Navigation/Tabs'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { colors, shadow } from '@mobi/component-library/Foundations'
import { useSearchParamState } from '@core/Utils/hooks/useSearchParamState'
import { MainContainer } from '@core/Components/Containers'
import { useDisableAppHeaderSticky } from '@core/Areas/AppHeader/hooks/useDisableAppHeaderSticky'
import type { FollowListTabNav, BetLoopProfile } from '@core/Areas/BetLoop/types'
import { FollowList } from './Components/FollowList'

export const ProfileFollowList: React.FC<{ profile: BetLoopProfile }> = ({ profile }) => {
  const scrollableContainerRef = React.useRef<HTMLDivElement>(null)

  const [currentTab, setCurrentTab] = useSearchParamState<FollowListTabNav>({
    values: ['followers', 'following'],
    defaultValue: 'followers',
    key: 'tab',
  })

  React.useEffect(() => {
    const el = scrollableContainerRef.current
    if (!el) return
    const handleScroll = () => (el.style.boxShadow = el.offsetTop > 2 ? shadow.md : 'none')
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [scrollableContainerRef])

  useDisableAppHeaderSticky()

  const handleTabClick = (tabContent: FollowListTabNav) => {
    setCurrentTab(tabContent, { shouldReplace: true })
  }

  return (
    <MainContainer background='surface300'>
      <PageHeader title={profile.displayName} />

      <TabNavWrapperStyled ref={scrollableContainerRef}>
        <Tabs>
          <TabButton
            content='Followers'
            isSelected={currentTab === 'followers'}
            onClick={() => handleTabClick('followers')}
          />
          <TabButton
            content='Following'
            isSelected={currentTab === 'following'}
            onClick={() => handleTabClick('following')}
          />
        </Tabs>
      </TabNavWrapperStyled>

      <FollowList key={currentTab} currentList={currentTab} profileId={profile.id} />
    </MainContainer>
  )
}

// ======
// Styles
// ======

const TabNavWrapperStyled = styled.div({
  position: 'sticky',
  top: 0,
  zIndex: 1,
  background: colors.white,
  transition: 'box-shadow 0.125s ease',
})
